export default class Converter {
  constructor(data) {
    this.data = data;
    this.offsets = [];
    this.saveOffset = false;
    this.isItems = false;
    this.clearOffset = 0;
    this.items = null;
    this.sheetCount = 0;
  }

  DFMToJSON(data, store) {
    if (!data && store) {
      this.$store.commit("SET_ERROR", { er: 'Данные дизайна (DFM) пусты. Проверьте настройки объекта.', source: ['DFMToJSON'] });
      return []
    }
    const result = [];

    const objectText = data.split("object");

    let sum = {};
    for (const text of objectText) {
      if (text.length > 2) {
        let begin = text.indexOf(' ');
        const end = text.indexOf('\r\n');
        const name = text.substr(begin + 1, end);
        begin = name.indexOf(' ');
        const type = name.substr(begin + 1, end).trim();
        let element = null;
        switch (type) {
          case 'TKtmLabel':
            element = this.createLabel(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TPanel':
            element = this.createPanel(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmStateInterpeter':
            element = this.createStateInterpreter(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmIndicator':
            element = this.createIndicator(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmMeter':
            element = this.createMeter(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmCoolPump':
            element = this.createCoolPump(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmValve':
            element = this.createValve(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmPipeLineH':
            element = this.createPipeline(text, end + 4, name, 'pipeline_horizontal')
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmPipeLineV':
            element = this.createPipeline(text, end + 4, name, 'pipeline_vertical')
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmPipeLine90rt':
            element = this.createPipeline(text, end + 4, name, 'pipeline_90_rightup')
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKtmPipeLine90rb':
            element = this.createPipeline(text, end + 4, name, 'pipeline_90_rightbottom')
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TcxButton':
            element = this.createButton(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKRON4Image':
            element = this.createImage(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TcxTextEdit':
            element = this.createTextEdit(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TcxMaskEdit':
            element = this.createMaskEdit(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TcxLabel':
            element = this.createCxLabel(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TLabel':
            element = this.createCxLabel(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TKRONResourceImage':
            element = this.createResourceImage(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element && Object.keys(element).length) {
              result.push(element);
            }
            break;
          case 'TcxImageComboBox':
            element = this.createDropdown(text, end + 4, name)
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TcxTabSheet':
            element = this.createTabSheet(text, end + 4, name)
            this.sheetCount = this.sheetCount + 1;
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          case 'TcxPageControl':
            this.sheetCount = 0;
            this.offsets.push({ x: 0, y: 0 });
            sum[type] = sum[type] ? sum[type] + 1 : 1;
            if (element)
              result.push(element);
            break;
          default:
            this.prepeaOffset(text, end + 4, name)
            sum[name] = 'нету'
            break;
        }
      }
    }
    console.log(result);
    return result
  }
  prepeaOffsetNew(text, begin/*, name*/) {
    this.saveOffset = false;
    this.clearOffset = 0;
    const ends = this.getListIdxEnd(text);
    let result = '';
    if (ends.length === 0) {
      result = text.substr(begin, text.length - 1);
      this.saveOffset = true;
    } else {

      result = text.substr(begin, ends[0] - 25);
      if (ends.length > 1) {
        this.clearOffset = ends.length - 1;
      }
    }
    return result;
  }
  prepeaOffset(text, begin/* , name */) {
    this.saveOffset = false;
    this.isItems = false;
    this.clearOffset = 0;
    const ends = this.getListIdxEnd(text);
    let result = '';
    if (ends.length === 0) {
      result = text.substr(begin, text.length - 1);

      this.saveOffset = true;
    } else {
      if (ends.length > 1 && text.indexOf('Properties.Items') > 1) {
        this.isItems = true;
        if (text.indexOf('end\r\nend') > -1 || text.indexOf('end\r\n  end') > -1) {
          result = text.substr(begin, ends[ends.length - 2] - 1);
        } else {
          result = text.substr(begin, ends[ends.length - 1] - 25);
        }
      } else {
        result = text.substr(begin, ends[0] - 23);//25
        if (ends.length > 1) {
          this.clearOffset = ends.length - 1;
        }
      }
    }
    return result;
  }
  prepareText(text, begin, name) {
    let result = this.prepeaOffset(text, begin, name);
    result = result.trim();
    result = result.replaceAll(' =', '":');
    result = result.replaceAll('    ', ' "');
    if (this.isItems) {
      const { object, items } = this.prepareItemText(result)
      result = object;
      this.items = items;
    }
    const arr = result.split('\r\n');
    const arrRes = this.prepareArr(arr)
    result = arrRes.join(',');
    result = result.replaceAll('"  ', '"');
    let offset = this.getOffset();
    result = `{ "${result}, "x":${offset.x}, "y":${offset.y + 24} }`;
    if (this.clearOffset) {
      //console.log(this.offsets.length + '-' + this.clearOffset);
      this.offsets.length = this.offsets.length - this.clearOffset;
    }
    result = result.replaceAll('" "', '"');
    return result
  }
  prepareArr(arr) {
    let arrRes = []
    arr.forEach(element => {
      const index = element.indexOf(': ');
      if (index > -1) {
        const word = element[index + 2]
        if (!isNaN(parseFloat(word)) && isFinite(word))
          arrRes.push(element)

        else {
          element = this.insert(element, '"', index + 2)
          element = element + '"'
          arrRes.push(element)
        }
      }
    });
    return arrRes;
  }
  prepareItemText(text) {
    const begin = text.indexOf('Properties.Items');
    const end = text.indexOf('end>');
    if (begin === -1 || end === -1) {
      console.error('нечего готовить', begin, end);
      return;
    }
    const object = text.substring(0, begin - 1) + text.substring(end + 4, text.length)
    let arr = text.substring(begin + 20, end + 3).split('\r\n');
    let arrRes = []
    arr.forEach(element => {
      const index = element.indexOf(': ');
      if (index > -1) {
        const word = element[index + 2]
        if (!isNaN(parseFloat(word)) && isFinite(word))
          arrRes.push(element)
        else {
          element = this.insert(element, '"', index + 2)
          element = element + '"'
          arrRes.push(element)
        }
      } else arrRes.push(element)
    });
    let items = [];
    let resultItems = [];
    arrRes.forEach(element => {
      const indexBegin = element.indexOf('item');
      const indexEnd = element.indexOf('end');
      if (indexBegin > -1) items.push('');
      if (indexEnd == -1 && indexBegin == -1 && element != '') {
        items[items.length - 1] = items[items.length - 1] + (items[items.length - 1].length > 0 ? ',' : '') + element.replaceAll('" "', '"');
      }
    })

    // eslint-disable-next-line no-unused-vars
    items.forEach(element => {
      resultItems.push(JSON.parse('{' + element + '}'));
    })

    return {
      object: object,
      items: resultItems
    }
  }
  createLabel(text, begin, name) {

    let json;
    try {
      text = this.prepareText(text, begin, name);
      json = JSON.parse(text);

    } catch (error) {
      console.error(error);
    }
    const result = {
      typeName: "heading",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        fill: "black",
        text_anchor: "start",
        hint: "",
        //name: name,
        heading_caption: this.convertPascalStrToString(json.Caption),
      }
    }
    return result
  }
  createCxLabel(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('  ', ' "');
      text = text.replaceAll('" "', ' "');
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
      console.error(text);
    }

    const result = {
      typeName: "heading",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width || 100,
        height: json.Height || 13,
        fill: "black",
        text_anchor: "start",
        hint: "",
        //  name: name,
        heading_caption: this.convertPascalStrToString(json.Caption),
      }

    }
    return result
  }
  createPanel(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('  ', ' "');


      text = text.replaceAll('" " " " "', '');
      text = text.replaceAll('" "', ' "');
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
      console.error(text);
    }
    if (this.saveOffset) {
      this.offsets.push({ x: json.Left, y: json.Top });
    }
    const result = {
      typeName: "panel",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: "",
        PropertyURI: "",

      },
    }
    return result
  }
  createStateInterpreter(text, begin, name) {
    let json;

    try {
      json = JSON.parse(this.prepareText(text, begin, name));
    } catch (error) {
      console.error(error);
      console.error(text);
    }

    const result = {
      typeName: "state_interpreter",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: this.convertPascalStrToString(json.Caption),
        PropertyURI: this.preparePropertyURI(json['DataController.PropertyURI'])
        //PropertyURI: this.convertPascalStrToString(json['DataController.PropertyURI']),
        //Caption: this.convertPascalStrToString(json.Caption),
        //"DataController.PropertyName": this.convertPascalStrToString(json['DataController.PropertyName']),
        // "DataController.PropertyURI": this.convertPascalStrToString(json['DataController.PropertyURI']),
        // "DataController.PropertyURIsource": tfhis.convertPascalStrToString(json['DataController.PropertyURIsource']),
      },
    }

    return result
  }
  createIndicator(text, begin, name) {
    let json;
    console.log(json);

    console.log(this.prepareText(text, begin, name));
    try {

      json = JSON.parse(this.prepareText(text, begin, name));
    } catch (error) {
      console.error(error);
      console.error(this.prepareText(text, begin, name));
    }

    const result = {
      typeName: "indicator",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: this.convertPascalStrToString(json.Caption),
        PropertyURI: this.preparePropertyURI(json['DataController.PropertyURI']),
        round: '2',
      },
    }

    return result
  }
  createMeter(text, begin, name) {
    let json;
    try {
      json = JSON.parse(this.prepareText(text, begin, name));
    } catch (error) {
      console.error(error);
      console.error(text);
    }
    const result = {
      typeName: "drawing",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: "",
        src: "meter.svg",
      },
    }
    return result
  }
  createCoolPump(text, begin, name) {
    let json;
    try {
      json = JSON.parse(this.prepareText(text, begin, name));
    } catch (error) {
      console.error(error);
      console.error(text);
    }
    const result = {
      typeName: "cool_pump",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: this.convertPascalStrToString(json['DataController.PropertyName']),
        PropertyURI: this.preparePropertyURI(json['DataController.PropertyURI'])
      },
    }
    return result
  }
  createValve(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('" "', '"');
      json = JSON.parse(text);

    } catch (error) {
      console.error(error);
      console.error(text);
    }
    const result = {
      typeName: "valve",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: this.convertPascalStrToString(json['DataController.PropertyName']),
        PropertyURI: this.preparePropertyURI(json['DataController.PropertyURI'])
      },
    }
    return result
  }
  createPipeline(text, begin, name, typeName = "pipeline_horizontal") {

    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('" "', '"');
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
      console.error(text);
    }
    const result = {
      typeName: typeName,
      attrList: {
        x: Number(json.Left + json.x),
        y: Number(json.Top + json.y),
        width: json.Width,
        height: json.Height,
        hint: this.convertPascalStrToString(json['DataController.PropertyName']),
        PropertyURI: this.preparePropertyURI(json['DataController.PropertyURI'])
      },
    }
    console.log("!!!!!!!!!!!!!!!pipeline_horizontal", result);
    return result
  }
  createButton(text, begin, name) {

    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('  ', ' "');
      text = text.replaceAll('" "', ' "');
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
    }
    const result = {
      typeName: "button_",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        fill: "gray",
        heading_caption: this.convertPascalStrToString(json['Caption']),
      },
    }
    return result
  }
  createImage(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('" " " " " "', '');
      text = text.replaceAll('" "', ' "');
      // json = this.prepareText(text, begin, name));
      json = JSON.parse(text);

    } catch (error) {
      console.error(error);
      console.error(text);
    }
    const result = {
      typeName: "icon",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        src: (json.ImageIndex ? json.ImageIndex : '0') + '.png',
      },
    }
    return result;
  }
  createTextEdit(text, begin, name) {

    let json;
    try {

      if (text.indexOf('Hint') !== -1 && text.indexOf('Margins.') !== -1) {

        text = text.substring(0, text.indexOf('Hint')) + text.substring(text.indexOf('Margins.'), text.length - 1)
      }

      text = this.prepareText(text, begin, name);

      text = text.replaceAll('  ', ' "');
      text = text.replaceAll('" "', ' "');

      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
    }
    const result = {
      typeName: "editor",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: 22,
        fill: "#f8f9fa",
        text_anchor: "start",
        hint: "",
        heading_caption: this.convertPascalStrToString(json.Text),
        PropertyURI: null
      }
    }
    return result
  }
  createMaskEdit(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('  ', ' "');
      text = text.replaceAll('" "', ' "');
      text = text.replaceAll('\'', '');
      text = text.replaceAll('\\', '');
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
    }
    const result = {
      typeName: "editor",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: 22,
        fill: "#f8f9fa",
        text_anchor: "start",
        hint: "",
        PropertyURI: null,
        heading_caption: this.convertPascalStrToString(json.Text),
      }
    }
    return result
  }
  createDropdown(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
    }
    const result = {
      typeName: "dropdown_",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: 22,
        PropertyURI: '',
        options: (this.isItems && this.items) ? this.items.map(item => ({
          id: item.Value === 'False' ? false : item.Value === 'True' ? true : item.Value,
          image_index: item.ImageIndex,
          name: this.convertPascalStrToString(item.Description),
        })) : [],
      }
    }
    return result
  }
  createResourceImage(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      for (let i = 0; i < text.length; i++) {
        if (text[i] == '\\') {
          text = this.insert(text, '\\', i);
          break;
        }
      }
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
      console.error(text);
    }
    let result = {}
    switch (this.convertPascalStrToString(json['ResourceName'])) {
      case 'Насосы\\Насос 6 зеленый':
        result = {
          typeName: "cool_pump",
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }

        break;
      case 'Клапаны\\Ручной клапан 3 Зеленый':
        result = {
          typeName: "valve",
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Длинный горизонтальный газопровод':
        result = {
          typeName: 'pipeline_horizontal',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Длинные вертикальные газовые трубы':
        result = {
          typeName: 'pipeline_vertical',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Газовая труба 90-градусная кривая 4':
        result = {
          typeName: 'pipeline_90_rightup',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Газовая труба 90-градусная кривая 2':
        result = {
          typeName: 'pipeline_90_rightbottom',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Газовая труба 90-градусная кривая 1':
        result = {
          typeName: 'pipeline_90_leftbottom',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Газовая труба 90-градусная кривая 3':
        result = {
          typeName: 'pipeline_90_leftup',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Емкости\\Очень гладкий резервуар 4':
        result = {
          typeName: 'tank',
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: '',
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Датчики\\Аналоговый датчик':
        result = {
          typeName: "drawing",
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: "",
            src: "meter.svg",
          },
        }
        break;
      case 'Трубы\\Длинные горизонтальные медные трубы':
        result = {
          typeName: "pipeline_horizontal",
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: "",
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Короткая горизонтальная медная труба':
        result = {
          typeName: "pipeline_horizontal",
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: "",
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      case 'Трубы\\Короткая вертикальная медная труба':
        result = {
          typeName: "pipeline_vertical",
          attrList: {
            x: json.Left + json.x,
            y: json.Top + json.y,
            width: json.Width,
            height: json.Height,
            hint: "",
            PropertyURI: 'PropertyURI',
          },
        }
        break;
      default:
        break;
    }
    /*const result = {
      typeName: "cool_pump",
      attrList: {
        x: json.Left + json.x,
        y: json.Top + json.y,
        width: json.Width,
        height: json.Height,
        hint: this.convertPascalStrToString(json['DataController.PropertyName']),
        PropertyURI: this.preparePropertyURI(json['DataController.PropertyURI'])
      },
    }*/
    return result;
  }
  createTabSheet(text, begin, name) {
    let json;
    try {
      text = this.prepareText(text, begin, name);
      text = text.replaceAll('  ', ' "');
      text = text.replaceAll('" " " " "', '');
      text = text.replaceAll('" "', ' "');
      json = JSON.parse(text);
    } catch (error) {
      console.error(error);
      console.error(text);
    }
    if (this.saveOffset) {

      this.offsets.push({ x: 1, y: 450 * this.sheetCount });

    }
    const result = {
      typeName: "panel",
      attrList: {
        x: 920,
        y: 530,
        width: 50,
        height: 50,
        hint: this.convertPascalStrToString(json.Caption),
        PropertyURI: "",

      },
    }
    return result
  }
  getValue(text, key) {
    let result = null;
    const item = `${key} = `
    const begin = text.indexOf(item) + item.length;
    return result + begin
  }
  convertPascalStrToString(strOld) {
    if (strOld == '')
      return ''
    if (strOld === undefined)
      return null
    let result = '',
      strNew = '',
      strUni = '#1072#1073#1074#1075#1076#1077#9576#1078#1079#1080#9559#169 #1081#1082#1083#1084#1085#1086#1087#1088#1089#1090#1091#1092#1093#1094#1095#1096#1097#1102#1103#1100#1040#1041#1042#1043#1044#1045#9561#1046#1047#1048#9569#9553#1049#1050#1051#1052#1053#1054#1055#1056#1057#1058#1059#1060#1061#1062#1063#1064#1065#1070#1071#1068#9575#1099#1067#1105#1025#1101#1069#1098#1066',
      strWin = 'абвгде╨жзи╗©йклмнопрстуфхцчшщюяьАБВГДЕ╙ЖЗИ╡║ЙКЛМНОПРСТУФХЦЧШЩЮЯЬ╧ыЫёЁэЭъЪ';
    if (strOld.indexOf('#') === -1) {
      result = strOld
    }
    else {

      strNew = strOld;
      const len = strWin.length;
      for (let index = 0; index < len; index++) {
        const str = strWin[index];

        const element = strUni.slice(index * 5, 5 * (index + 1));

        if (element != '')
          strNew = strNew.replaceAll(element.trim(), str)
      }
      result = strNew
    }
    return result.replaceAll("'", "")
  }
  getOffset() {
    const result = { x: 0, y: 0 }
    this.offsets.forEach(item => {
      result.x = result.x + item.x;
      result.y = result.y + item.y;
    });

    return result;
  }
  insert(str, substr, pos) {
    var array = str.split('');
    array.splice(pos, 0, substr);
    return array.join('');
  }
  getListIdx(str, substr) {
    let listIdx = []
    let lastIndex = -1
    while ((lastIndex = str.indexOf(substr, lastIndex + 1)) !== -1) {
      listIdx.push(lastIndex)
    }
    return listIdx
  }
  getListIdxEnd(str) {
    let listIdx = []
    let lastIndex = -1
    while ((lastIndex = str.indexOf('end', lastIndex + 1)) !== -1) {
      if (str[lastIndex + 3] != '>')
        listIdx.push(lastIndex)
    }
    return listIdx
  }
  preparePropertyURI(uri) {
    const uriFit = this.convertPascalStrToString(uri);
    if (!uriFit) return "PropertyURI"
    const arr = this.getListIdx(uriFit, '.');

    if (arr.length > 0) {
      return uriFit.substr(arr[0] + 1, uriFit.length - 1);
    } else return uriFit;

  }

}



